import { Component, OnInit,Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-delete-gedcom',
  templateUrl: './delete-gedcom.component.html',
  styleUrls: ['./delete-gedcom.component.scss']
})
export class DeleteGedcomComponent implements OnInit {

  
  constructor(
    public dialogRef: MatDialogRef<DeleteGedcomComponent>,
    @Inject(MAT_DIALOG_DATA) public modalData: any,
  ) { }

  gedcomName: any

  ngOnInit(): void {
    this.gedcomName = this.modalData.gedcomName
    if (this.modalData.delay) {
      setTimeout(() => {
        this.dialogRef.close()
      }, this.modalData.delay);
    }
  }


  closeModal() {
    this.dialogRef.close();
  }

}
